import './Justification.css';

function Justification({ justification, marketData }) {
  if (!justification || justification.length === 0) {
    return null;
  }

  return (
    <div className="justification">
      <h3>Pricing Rationale</h3>

      <div className="justification-content">
        {justification.map((line, index) => {
          // Style different line types
          if (line.startsWith('💡')) {
            return (
              <p key={index} className="strategy-line">
                {line}
              </p>
            );
          }
          if (line.startsWith('  +') || line.startsWith('  -')) {
            return (
              <p key={index} className={`adjustment-line ${line.includes('+') ? 'positive' : 'negative'}`}>
                {line}
              </p>
            );
          }
          if (line === '') {
            return <br key={index} />;
          }
          return <p key={index}>{line}</p>;
        })}
      </div>

      {/* Data freshness note */}
      {marketData && (
        <div className="data-freshness">
          <span className="freshness-icon">📊</span>
          <span>
            Based on {marketData.sampleSize} recent rentals in {marketData.neighborhood}
            {marketData.lastUpdated && ` • Data from ${marketData.lastUpdated}`}
          </span>
        </div>
      )}
    </div>
  );
}

export default Justification;
